export const formatSchedulerTimestamp = date => {
  const newDate = new Date(date);
  const isoTime = newDate.toISOString();
  return isoTime;
};